export class ISelectable {
    IsSelected: boolean;
}
